module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Sae3p8/tc-custom/9783962727178.jpg",
      "alt": "This image is the cover for the book The Story of Porcelain, Correct Times"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Story of Porcelain, Correct Times\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Excerpt: \"I have seen some of the old Mexican or Aztec pottery,\" declared Dr. Swift, \"and it was very interesting. It was of reddish clay, and I was told   it was much like the variety made in Peru. Not only were there roughly modeled dishes and jars in the collection, but also all sorts of strange clay idols. You see, instead of worshipping the gods of goodness, Theo, these early peoples thought they could propitiate the gods of evil if they worshipped them instead; accordingly they made all sorts of grotesque images, some of them very hideous. None of this clay work was glazed, of course, for at that time men had not yet discovered that they could put a glaze over the surface of objects and thus protect them and render them water-tight. It was a great pity that Cortez and his followers destroyed this early Mexican civilization, which was surprisingly advanced.\"")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sara Ware Bassett\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sara Ware Bassett (1872 – 1968) was an American author of fiction and nonfiction. Her novels primarily deal with New England characters, and most of them are set in two fictional Cape Cod villages she created, Belleport and Wilton. Her first novel, \"Mrs. Christy's Bridge Party\", was published in 1907. She subsequently wrote more than 40 additional novels, continuing to write and publish into the late 1950s. Many of her novels focus on love stories and humorously eccentric characters. (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1291cb2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0